import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './InlineEditButtons.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "buttons-wrapper" },
    [
      _c(
        "Button",
        {
          staticClass: "box-shadow-wrapper",
          attrs: { spacing: "none", "data-cy": "submit-button" },
          on: { click: _vm.onConfirm, focus: _vm.onFocus, blur: _vm.onBlur }
        },
        [
          _c("EditorDoneIcon", {
            attrs: { slot: "icon-before", size: "small" },
            slot: "icon-before"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Button",
        {
          staticClass: "box-shadow-wrapper",
          attrs: { spacing: "none", "data-cy": "cancel-button" },
          on: { click: _vm.onCancel, focus: _vm.onFocus, blur: _vm.onBlur }
        },
        [
          _c("EditorCloseIcon", {
            attrs: { slot: "icon-before", size: "small" },
            slot: "icon-before"
          })
        ],
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-1ba7d569";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Form/InlineEditButtons.vue.js